import { MULTIPART_FORM_DATA_HEADERS as headers } from '@/constants';
import requester from '@/lib/axios';
import JsonApiResponse from '@/models/JsonApiResponse';
import Resource, { ResourceDTO } from '@/models/Resource';
import { BaseFilters } from '@/models/Service';
import { jsonToFormData } from '@/utils/shared/jsonToFormData';
import {
  ServiceUploadingOptions,
  toAxiosUploadConfig,
} from '@/utils/shared/uploadProgress';

const buildBaseUrl = (lessonId: number) => `lessons/${lessonId}/resources`;

export type ListLessonResourceFilters = BaseFilters;

export const listLessonResources = async (
  lessonId: number,
  filters: ListLessonResourceFilters = {},
) => {
  const { data } = await requester().get<JsonApiResponse<Resource>>(
    `${buildBaseUrl(lessonId)}/`,
    { params: filters },
  );
  return data;
};

export const createLessonResource = async (
  lessonId: number,
  body: Partial<ResourceDTO>,
  options: ServiceUploadingOptions = {},
) => {
  const formData = jsonToFormData(body);
  const { data } = await requester().post<Resource>(
    `${buildBaseUrl(lessonId)}/`,
    formData,
    { headers, ...toAxiosUploadConfig(options) },
  );
  return data;
};

export const updateLessonResource = async (
  lessonId: number,
  resourceId: number,
  body: Partial<ResourceDTO>,
  options: ServiceUploadingOptions = {},
) => {
  const formData = jsonToFormData(body);
  const { data } = await requester().patch<Resource>(
    `${buildBaseUrl(lessonId)}/${resourceId}/`,
    formData,
    { headers, ...toAxiosUploadConfig(options) },
  );
  return data;
};

export const removeLessonResource = async (
  lessonId: number,
  resourceId: number,
) => {
  await requester().delete<void>(`${buildBaseUrl(lessonId)}/${resourceId}/`);
};

export const reorderLessonResources = async (
  lessonId: number,
  resources: { id: number }[],
) => {
  await requester().patch<void>(`${buildBaseUrl(lessonId)}/order/`, resources);
};

export const downloadLessonResource = async (
  lessonId: number,
  resourceId: number,
) => {
  const { data } = await requester().get<Blob>(
    `${buildBaseUrl(lessonId)}/${resourceId}/download/`,
    { responseType: 'blob' },
  );
  return data;
};
